import './styles/DenseCalendar.scss';

import { isAfter, isBefore, isSameDay } from 'date-fns';
import { FunctionComponent } from 'react';
import ReactCalendar, { CalendarProps } from 'react-calendar';
import 'react-calendar/dist/Calendar.css';

interface DenseCalendarProps {
  startDate: Date;
  endDate: Date;
  markDates?: boolean;
}

export const DenseCalendar: FunctionComponent<
  DenseCalendarProps &
    Omit<CalendarProps, 'showNeighboringMonth' | 'tileClassName' | 'prev2Label' | 'next2Label'>
> = ({ endDate, startDate, markDates, ...restProps }) => {
  const applyClasses = ({ date, view }) => {
    if (view === 'month') {
      if (
        (isAfter(date, new Date(startDate)) || isSameDay(date, new Date(startDate))) &&
        (isBefore(date, new Date(endDate)) || isSameDay(date, new Date(endDate)))
      ) {
        return 'dense-calendar__marking';
      }
      return null;
    }
    return null;
  };
  return (
    <ReactCalendar
      {...restProps}
      showNeighboringMonth={false}
      tileClassName={markDates ? applyClasses : undefined}
      defaultActiveStartDate={new Date(startDate)}
      className="dense-calendar__react-calendar"
      prev2Label={null}
      next2Label={null}
    />
  );
};
